export const mepRef31Options = ['yes', 'no', 'unsure'] as const;

export const mepRef31OptionsLabels: Record<(typeof mepRef31Options)[number], string> = {
  yes: 'Yes',
  no: 'No',
  unsure: 'Unsure',
} as const;
